import React, { useEffect, useState } from 'react'

import { GoalWizardStepper } from 'components/GoalWizard'

const StepperProgress = ({ data, activeStep, setActiveStep }) => {
  const [activeProgress, setActiveProgress] = useState(0)

  useEffect(() => {
    if (data) {
      setActiveProgress(
        (index => (index < 0 ? 4 : index))(
          [
            !!data.month && !!data.storeId,
            typeof data.salary?.directCommission === 'boolean' &&
              typeof data.salary === 'object' &&
              typeof data.distribute === 'boolean' &&
              data.sections?.length > 0 &&
              typeof data.config?.commission?.storeSold === 'boolean',
            data.dsr >= 0 && data.salary?.base > 0 && data.mainGoals.ticket > 0,
            data.config?.commission?.fixed?.commission >= 0 &&
              data.days?.length > 0 &&
              data.monthGoals?.length > 0 &&
              data.usersWorking?.length > 0
          ].indexOf(false)
        )
      )
    }
  }, [data])

  return (
    <GoalWizardStepper
      activeStep={activeStep}
      progressStep={activeProgress}
      onStepClick={setActiveStep}
    />
  )
}

export default StepperProgress
